export const withAbortController = (wrappedFetch, context) => (input, options) => {
    if (!context.abortController && typeof AbortController !== 'undefined') {
        context.abortController = new AbortController();
    }
    const pendingRequest = wrappedFetch(input, {
        ...options,
        ...(context.abortController && {
            signal: context.abortController.signal,
        }),
    });
    if (!context.abortController) {
        return pendingRequest;
    }
    const { signal } = context.abortController;
    return new Promise((res, rej) => pendingRequest
        .then(res, e => {
        if (signal.aborted && signal.reason && signal.throwIfAborted) {
            signal.throwIfAborted();
        }
        throw e;
    })
        .catch(rej));
};
//# sourceMappingURL=abort-controller.js.map